function observeValue(options) {
    const { value_to_observe, interval = 500, timeout = 50000, callback, timeoutCallback } = options;
    let elapsedTime = 0;

    const intervalId = setInterval(() => {
        elapsedTime += interval;
        if (typeof window[value_to_observe] !== 'undefined') {
            clearInterval(intervalId);
            callback(window[value_to_observe]);
        } else if (elapsedTime >= timeout) {
            clearInterval(intervalId);
            if (timeoutCallback) {
                timeoutCallback();
            }
        }
    }, interval);
}
window.observeValue = observeValue;

const debounce = (function () {
    let timer = 0;
    return function (callback, delay) {
        clearTimeout(timer);
        timer = setTimeout(callback, delay);
    };
})();
window.debounce = debounce;

function toggleSlide(options) {
    const { container, closeContainer = false, onContainerOpen } = options;
    if (container) {
        if (!container.classList.contains('active') && !closeContainer) {
            container.classList.add('active');
            container.style.height = 'auto';

            let height = container.clientHeight + 'px';
            container.style.height = '0px';
            setTimeout(function () {
                container.style.height = height;
                if (onContainerOpen) {
                    onContainerOpen();
                }
            }, 0);
            setTimeout(function () {
                container.style.overflow = 'visible';
            }, 500);
        } else {
            container.style.overflow = 'hidden';
            if (closeContainer) {
                container.classList.remove('active');
                return;
            }
            container.style.height = '0px';
            container.addEventListener(
                'transitionend',
                function () {
                    container.classList.remove('active');
                },
                {
                    once: true,
                }
            );
        }
    }
}
window.toggleSlide = toggleSlide;

function toggleFormDropdown(event, elementId) {
    if (event.type === 'click' || (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))) {
        const dropdown = document.getElementById(elementId);
        const options = {
            container: dropdown,
        };
        toggleSlide(options);
    }
}
window.toggleFormDropdown = toggleFormDropdown;

function selectOption(option, dropdownId = 'selectedOption') {
    const selectedOption = document.getElementById(dropdownId);
    selectedOption.textContent = option;
    const dropdown = document.getElementById('form-dropdown');
    const options = {
        container: dropdown,
    };
    toggleSlide(options);
}
window.selectOption = selectOption;

function formatDate(date, format = 'MM/DD/YYYY') {
    if (date === null || date === '' || date === undefined) return '';
    const selectedDate = new Date(date);
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const year = selectedDate.getFullYear();

    if (format === 'MM-DD-YYYY') {
        return `${month}-${day}-${year}`;
    }
    else if (format === 'YYYY-MM-DD') {
        return `${year}-${month}-${day}`;
    }
    else if (format === 'MM/DD/YYYY') {
        return `${month}/${day}/${year}`;
    }
    else if (format === 'MM/DD/YY h:mmAM/PM') {
        let hours = selectedDate.getHours();
        const minutes = selectedDate.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 (midnight) to 12
        return `${month}/${day}/${year} • ${hours}:${minutes}${ampm}`;
    }
    else {
        throw new Error(`Unsupported format: ${format}`);
    }
}
window.formatDate = formatDate;
export { formatDate };

window.showCustomDialog = function showCustomDialog(id) {
    const dialog = document.getElementById(id);
    if (dialog) {
        dialog.setAttribute('show-dialog', 'true');
    }
};
window.hideCustomDialog = function hideCustomDialog(id) {
    const dialog = document.getElementById(id);
    if (dialog) {
        dialog.setAttribute('show-dialog', 'false');
    }
};

// it will fix AG Grid header, when its reaches top of the page
window.fixAgGridHeader = function fixAgGridHeader() {
    if (Boolean(window.scrollHeader) == true || Boolean(window.fixedAgGridHeader) == true) {
        const pageHeader = document.getElementById('main-header-v2');
        if (pageHeader.classList.contains('fixed')) {
            pageHeader.classList.remove('fixed');
            pageHeader.classList.add('relative');
        }
        const agHeader = document.querySelector('.ag-header');
        if (window.scrollY >= 319) {
            agHeader.style.position = 'fixed';
            agHeader.style.top = '0';
            agHeader.style.zIndex = '99';
            agHeader.style.width = 'calc(100% - 84px)';
        } else {
            agHeader.style.position = 'static';
            agHeader.style.zIndex = '0';
            agHeader.style.width = '100%';
        }
    }
};

// CUSTOM THEME FOR HL
function primeVueConfiguration(Theme, definePreset) {
    function setPreset() {
        return definePreset(Theme, {
            components: {
                chip: {
                    colorScheme: {
                        light: {
                            remove: {
                                icon: {
                                    // color: '#000',
                                    // background: '#ffff',
                                },
                            },
                            background: '#000',
                            color: '#ffff',
                        },
                    },
                },
            },
            semantic: {
                primary: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}',
                },
                colorScheme: {
                    light: {
                        primary: {
                            color: '{zinc.950}',
                            inverseColor: '#ffffff',
                            hoverColor: '{zinc.900}',
                            activeColor: '{zinc.800}',
                        },
                        highlight: {
                            background: '{zinc.950}',
                            focusBackground: '{zinc.700}',
                            color: '#ffffff',
                            focusColor: '#ffffff',
                        },
                    },
                },
            },
        });
    }
    return {
        theme: {
            preset: setPreset(),
            options: {
                darkModeSelector: '.my-app-dark',
            },
        },
        zIndex: {
            menu: 1030,
            overlay: 1040,
            modal: 1050,
            //toast: 1060
            tooltip: 1070,
        },
    };
}
window.primeVueConfiguration = primeVueConfiguration;
export { primeVueConfiguration };

function createCancelableRequest() {
    let abortController = null;

    return {
        getSignal() {
            // Cancel the previous request if it exists
            if (abortController) {
                abortController.abort();
            }
            abortController = new AbortController();
            return abortController.signal;
        },
        //if you want to manually cancel the API request then invoke this method
        cancelRequest() {
            if (abortController) {
                abortController.abort();
            }
        },
    };
}
export { createCancelableRequest };

//   LAZY LOAD IMAGES THAT ADDED AS BACKGROUND-IMAGE
window.addEventListener('load', function () {
    const lazyBackgrounds = document.querySelectorAll('.lazy-bg');

    lazyBackgrounds.forEach((element) => {
        const bgUrl = element.getAttribute('data-bg-url');
        element.style.backgroundImage = `url(${bgUrl})`;
    });
});

//   TO HIDE DROPDOWNS WHEN CLICK OUTSIDE
function hideDropdowns(selectors) {
    selectors.forEach((selector) => {
        let idElement = document.getElementById(selector);
        let classElements = document.getElementsByClassName(selector);
        if (idElement) {
            idElement.style.display = 'none';
        } else if (classElements && classElements.length) {
            [...classElements].forEach((ele) => (ele.style.display = 'none'));
        }
    });
}
export { hideDropdowns };

// TO DYNAMICALLY REPLACE HTML WITH PLACEHODER
function replaceHTML(config) {
    const { placeholderId, loaderId, content, callback } = config;
    const placeholderElement = document.getElementById(placeholderId);
    const loader = document.getElementById(loaderId);
    if (typeof callback === 'function') callback();
    if (placeholderElement) {
        if (loader) loader.style.display = 'none';
        placeholderElement.innerHTML = content;
        // Extract and execute script tags
        const scriptTags = placeholderElement.getElementsByTagName('script');
        for (let i = 0; i < scriptTags.length; i++) {
            const scriptTag = document.createElement('script');
            if (scriptTags[i].src) {
                // If script has a src attribute, re-insert it into the DOM to load it
                scriptTag.src = scriptTags[i].src;
                document.body.appendChild(scriptTag);
            } else {
                // For inline scripts, execute the script content
                scriptTag.text = scriptTags[i].innerText;
                document.body.appendChild(scriptTag);
            }
        }
    }
}
export { replaceHTML };

function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
}
window.isMobile = isMobile;
export { isMobile };

function getAgGridRangeSelection(gridApi) {
    const ranges = gridApi.getCellRanges();
    if (!ranges || ranges.length === 0) {
        console.log('No ranges selected');
        return [];
    }
    const selectedData = [];
    ranges.forEach((range) => {
        const startRow = range.startRow.rowIndex;
        const endRow = range.endRow.rowIndex;

        for (let rowIndex = startRow; rowIndex <= endRow; rowIndex++) {
            const rowNode = gridApi.getDisplayedRowAtIndex(rowIndex);
            'data' in rowNode && selectedData.push(rowNode.data);
        }
    });
    return selectedData;
}
export { getAgGridRangeSelection };

// THIS METHOD SET DJANGO TEMPLATE DATA FOR JAVASCRIPT FILES
function setDjangoData(data = {}) {
    if (window.djangoData === undefined) {
        window.djangoData = {};
    }
    window.djangoData = { ...window.djangoData, ...data }
}
window.setDjangoData = setDjangoData;
export { setDjangoData };

function createDOMElement(config) {
    const {
        type = 'div',
        attributes = [],
        innerHTML = '',
        eventListeners = [],
        styles = {}
    } = config;
    if (!type) {
        throw new Error('The "type" property is required to create a DOM element.');
    }
    const element = document.createElement(type);
    // Set attributes
    if (Array.isArray(attributes)) {
        attributes.forEach(({ name, value }) => {
            element.setAttribute(name, value);
        });
    }
    if (innerHTML) {
        element.innerHTML = innerHTML;
    }
    // Attach event listeners
    if (Array.isArray(eventListeners)) {
        eventListeners.forEach(({ event, handler }) => {
            if (event && typeof handler === 'function') {
                element.addEventListener(event, handler);
            }
        });
    }
    // Apply styles
    if (styles && typeof styles === 'object') {
        Object.assign(element.style, styles);
    }
    return element;
}

window.createDOMElement = createDOMElement;
export { createDOMElement };
// Add padding and highlight the element
function highlightContainer({ timeout = 1000, element } = config) {
    removeHighlight(element)
    element.classList.add('highlighted-container', 'higlighted-element-BG', 'higlighted-element-transition');
    setTimeout(() => removeHighlight(element), timeout);
}

function removeHighlight(element) {
    element.classList.remove('higlighted-element-transition');
}
export { highlightContainer, removeHighlight }

function currencyFormatter(value) {
    if (value === null || value === '' || value === undefined) return '';
    return '$' + formatNumber(value);
}
export { currencyFormatter }

// normalise figure with comma
function formatNumber(number) {
    return Math.floor(number)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
export { formatNumber }

function googleMap() {
    // prettier-ignore 
    (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })
        ({ key: window.google_api_key, v: "weekly" });
}
export { googleMap }

function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}
export { scrollToTop }

function handleImageError(event, defaultImage) {
    if (defaultImage) {
        event.target.src = defaultImage;
    } else {
        event.target.style.display = 'none';
    }
}
export { handleImageError }

// Sticky AG Grid Horizontal Scrollbar 
// how to use: add row-data-updated event listener to the ag-grid and call this function after the row data is updated
// window.setTimeout(() => {
//     this.stickyAgGridHorizontalScrollbar();
// }, 200);
function stickyAgGridHorizontalScrollbar(config = {}) {
    const { theme = 'ag-theme-alpine', horizontalScrollbarOffset = 0 } = config;
    const scrollbar = document.querySelector('.ag-body-horizontal-scroll');
    const gridElement = document.querySelector(`.${theme}`);
    if (!scrollbar || !gridElement) return;

    const updateScrollbarPosition = () => {
        const gridRect = gridElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const gridBottom = gridRect.bottom;
        // If the grid's bottom is above the viewport bottom, adjust the scrollbar position
        if (gridBottom > windowHeight) {
            const bottomOffset = gridBottom - windowHeight - horizontalScrollbarOffset;
            scrollbar.style.bottom = `${bottomOffset}px`;
        } else {
            scrollbar.style.bottom = '0px';
        }
    };
    // Update on scroll and resize
    window.addEventListener('scroll', updateScrollbarPosition);
    window.addEventListener('resize', updateScrollbarPosition);
    // Initial update
    updateScrollbarPosition();
}
window.stickyAgGridHorizontalScrollbar = stickyAgGridHorizontalScrollbar;
export { stickyAgGridHorizontalScrollbar }

// SHOW ALL THOSE HORIZONTAL FILTERS WHICH CAN BE ACCOMODATE IN SINGLE ROW, HIDE ALL OTHER FILTERS
function adjustInputVisibility() {
    const container = document.getElementById('horizontal-filters');
    const inputs = container.querySelectorAll('.horizontal-filter-field');
    if (window.innerWidth <= 768) {
        inputs.forEach((input) => {
            input.style.visibility = 'visible';
        });
        return;
    }
    const containerRect = container.getBoundingClientRect();
    inputs.forEach((input) => {
        const inputRect = input.getBoundingClientRect();
        // console.log('inputRect', inputRect.right, 'containerRect', containerRect.right, 'inputRect.left', inputRect.left, 'containerRect.left', containerRect.left)
        // Check if the input is fully visible in the container
        if (inputRect.right > containerRect.right || inputRect.left < containerRect.left) {
            input.style.visibility = 'hidden';
        } else {
            input.style.visibility = 'visible';
        }
    });
}
export { adjustInputVisibility }

// add extra space to target element when cards container has extra space during wrap
// container is the element that has total width
// card has some width 360px + 20px gap
// target is the element that will be resized to fit the available width
function createResponsiveLayout(config = {}) {
    const { containerSelector, cardSelector, targetSelector, cardDefaultWidth = 360, cardGap = 20 } = config;
    // Get container width
    const containerWidth = document.querySelector(containerSelector)?.clientWidth || 0;

    // Get item width
    const cardEl = document.querySelector(cardSelector);
    const cardWidth = (cardEl?.clientWidth || cardDefaultWidth) + cardGap;

    // Get target element
    const targetEl = document.querySelector(targetSelector);
    const targetWidth = targetEl?.clientWidth || 0;

    // Calculate available width and items per row
    const widthAvailable = containerWidth - targetWidth;
    const cardsPerRow = Math.floor(widthAvailable / cardWidth);

    // Calculate width available for target element
    const widthAvailableForTarget = containerWidth - (cardsPerRow * cardWidth);

    // Apply width to target element
    if (targetEl) {
        targetEl.style.width = `${widthAvailableForTarget}px`;
    }

    return {
        containerWidth,
        cardWidth,
        cardsPerRow,
        targetWidth: widthAvailableForTarget
    };
}
export { createResponsiveLayout }
